export default __webpack_public_path__ + "static/media/docs.43e949ef.svg";